export const Marquee = () => {
  const text = "BIRRIFICIO TRADIZIONALE";
  const items = Array(8).fill(text);
  return (
    <div
      className="border-y border-white/10 py-6 overflow-hidden bg-[#141A14]"
      data-testid="marquee"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0">
            {items.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="font-serif-display text-3xl md:text-5xl italic text-[#E8E2D2] px-8">
                  {t}
                </span>
                <span className="text-[#D47738] text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
